// Login & logout
export function login(state, lastVisit) {
  let identity = state.identity
  if (identity == 'partners') {
    let url = state.URLs.lineLogin + "?redirectUri=" + state.URLs.base + state.URLs.callback + '&scope=email&layout=email'
    window.location.href = url
  }
  else if (identity == 'users') {
    const scope = ['profile', 'openid', 'email']
    if (lastVisit)
      localStorage.setItem(state.storageKeys.lastVisit, state.URLs.base + lastVisit)
    else
      localStorage.setItem(state.storageKeys.lastVisit, document.URL);
    // before login
    const timestamp = Date.now()
    localStorage.setItem("login_token", timestamp)
    let url = state.URLs.lineLogin + 'client_id=' + state.channelID + '&redirect_uri=' + state.URLs.base + state.URLs.callback + '&scope=' + scope.join('%20') + '&state=' + timestamp
    window.location.href = url
  }
}
export function logout(state) {  
  let identity = localStorage.getItem(state.storageKeys.identity)
  let logoutUrl = localStorage.getItem(state.storageKeys.logoutUrl)  

  localStorage.clear();
  
  if (identity == 'partners' || identity == 'government')
    window.location.href = logoutUrl
  else if (identity == 'users')
    location.reload()
}


export function getUserProfile(storageKeys) {
  const token = localStorage.getItem(storageKeys.token)
  var name = null,
    url = null
  if (token) {
    if (localStorage.getItem(storageKeys.pictureUrl)) {
      url = localStorage.getItem(storageKeys.pictureUrl)
    }
    if (localStorage.getItem(storageKeys.displayName)) {
      name = localStorage.getItem(storageKeys.displayName)
    }
  }
  if (url == "null")
    url = null
  return [token, name, url]
}
